const DEFAULT_LOCALE = 'en-US';
const prodLocales = ['en-US', 'ko', 'ja', 'pt-BR', 'zh-Hant', 'es-419'];
const devLocales = [];
const locales = [...prodLocales];
const routeExposedLocales = [...prodLocales, ...devLocales];
if (process.env.NODE_ENV === 'development' ||
    process.env.IS_SLINGSHOT === 'true') {
    locales.push('pseudo');
    locales.push(...devLocales);
}
export { locales, devLocales, routeExposedLocales, prodLocales, DEFAULT_LOCALE, };
//# sourceMappingURL=locales.js.map